import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ReferralTracker from './utilities/ReferralTracker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
    <ReferralTracker/>
        <App />
    </BrowserRouter>
);
 